import React from 'react';

import styled from 'styled-components';
import {getProcedureTaskCore} from 'sweet-taskinfo';

import {gt} from 'app/utils/i18n';

import type {TaskInstanceSerializedType} from 'sweet-types';

interface Props {
  isCompleted: boolean;
  task: TaskInstanceSerializedType;
  stepId: string;
}

export function ProcedureStepProgressBar({
  isCompleted,
  task,
  stepId,
}: Props): JSX.Element | null {
  let percentageComplete = 0;

  // if the procedure-step is marked as completed in the overall task
  // we just ignore the completed steps and show it as 100% completed
  if (isCompleted) {
    percentageComplete = 100;
  } else {
    const taskCore = getProcedureTaskCore(task, stepId);

    if (taskCore.hasVersion === false) {
      return null;
    }

    percentageComplete = taskCore.percentComplete || 0;
  }

  return (
    <StyledThinProgressDiv
      title={gt('%d%% complete', percentageComplete.toFixed(0))}
    >
      <div
        className="progress-bar bg-info"
        style={{
          width: percentageComplete + '%',
        }}
      />
    </StyledThinProgressDiv>
  );
}
const StyledThinProgressDiv = styled.div.attrs<{height?: string}>({
  className: 'progress',
})<{height?: string}>`
  height: ${({height}) => (height != null ? height : '3px')};
`;
